import Vue from "vue";

export default {
    install () {
        Vue.prototype.$getAllContact = async function() {
            let result = [];
            try {
                const response = await this.$http.get('/contact');
                if (response.data && response.data.success) {
                    result = [].concat(response.data.data)
                }

                return result;
            } catch (e) {
                console.log(e.stack);
                return result;
            }
        };
    },
};